import { Datagrid, LongTextField } from "ra-friendsofbabba";
import { List as RaList, TextField } from "react-admin";

import Actions from "../component/list/Actions";
import { ExportMenuButton } from "../component/button";
import Filters from "./Filters";
import React from "react";

const List = (props) => {
  return (
    <RaList
      {...props}
      exporter={false}
      bulkActionButtons={false}
      sort={{ field: "id", order: "ASC" }}
      filters={<Filters />}
      actions={
        <Actions canExport={false} canCreate={false}>
          <ExportMenuButton choices={["xlsx"]} />
        </Actions>
      }
    >
      <Datagrid>
        <TextField source="id" />
        <LongTextField source="user" />
        <LongTextField source="context" />
        <TextField source="months" />
        <TextField source="days" />
      </Datagrid>
    </RaList>
  );
};
export default List;
